__turbopack_context__.v({
  "className": "herodisplay_73ca02dd-module__THycLa__className",
});
